"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LimitedWidthEditorialsModule = exports.FullWidthEditorialsModule = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const FullWidthEditorialsModule = exports.FullWidthEditorialsModule = (0, _mui.styled)('div')({
  boxSizing: 'border-box',
  width: '100%'
});
const LimitedWidthEditorialsModule = exports.LimitedWidthEditorialsModule = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  paddingOnMobile,
  theme
}) => ({
  boxSizing: 'border-box',
  maxWidth: '1306px',
  margin: theme.spacing(0, 'auto'),
  padding: theme.spacing(0, paddingOnMobile ? 3 : 0),
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 3)
  }
}));
